import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import quickytoolsAccount from './modules/quickytoolsAccount'

Vue.use(Vuex)

const isProduction = process.env.NODE_ENV === 'production'

// See https://vuex.vuejs.org/en/plugins.html
const logger = createLogger({
  collapsed: false // auto-expand logged mutations
})

export default new Vuex.Store({
  state: {},
  getters: {
    // Access in modules through rootGetters.
    isProduction: () => isProduction
  },
  modules: {
    quickytoolsAccount
    // Dynamically register other modules in components with registerModule/unregisterModule
  },
  strict: !isProduction,
  plugins: isProduction ? [] : [logger]
})
